import {connect} from 'react-redux';
import Contracts from './contracts';

export default connect()(Contracts)
